import { Box, Grid, Stack, Typography } from '@mui/material';
import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Define the interface for the component's props
interface MyWorkProps {
  temp?: string;
}

type WorkItem = {
  title: string;
  img: string;
  link: string;
};

const myWorkItems: WorkItem[] = [
  {
    title: 'Todo List',
    img: '/todoslist-app.png',
    link: '/todolist',
  },
  {
    title: 'Password Generator',
    img: '/password-generator-app.png',
    link: '/password-generator',
  },
  {
    title: 'Tasks',
    img: '/tasks-app.png',
    link: '/tasks',
  },
  {
    title: 'Conversion',
    img: '/conversion-app.png',
    link: '/conversion',
  },
  {
    title: 'Gym Treadmill App',
    img: '/vadesign-app.png',
    link: '/vadesign',
  },
];

// Functional Component using props and state
const MyWork: FC<MyWorkProps> = () => {
  const navigate = useNavigate();

  const handleRedirect = (link: string) => {
    navigate(link); // relative
    // OR
    // navigate('/dashboard/settings', { replace: true });
    // OR with state
    // navigate('/checkout', { state: { from: 'cart' } });
  };

  return (
    <Grid
      container
      spacing={3}
      sx={{
        marginTop: '50px',
        px: { xs: 2, md: 10, lg: 20, xl: 30 }, // responsive padding instead of fixed 200px
      }}
    >
      {myWorkItems.map((item) => (
        <Grid item md={12} lg={6} xl={4} key={item.title}>
          {/* <WorkItemCard item={item} handleRedirect={handleRedirect} /> */}
          <ProjectCard item={item} handleRedirect={handleRedirect} />
        </Grid>
      ))}
    </Grid>
  );
};

type WorkItemCardProps = {
  item: WorkItem;
  handleRedirect: (link: string) => void;
};

const WorkItemCard: FC<WorkItemCardProps> = ({ item, handleRedirect }) => {
  return (
    <Box
      sx={{
        width: '100%',
        // border: '1px solid #e9e9e9',
        borderRadius: '10px',
        textAlign: 'center',
        height: '500px',
        boxShadow: 'rgba(0, 0, 0, 0.04) 0px 4px 12px;',

        cursor: 'pointer', // Shows it's clickable
        userSelect: 'none', // Prevents text selection
        transition: 'all 0.2s ease', // Smooth hover/active
        // Hover effect
        '&:hover': {
          //   backgroundColor: '#5a5a5bff',
          borderColor: '#7a7a7aff',
          transform: 'scale(1.02)',
          //   boxShadow: 4,
          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px;',
        },

        // Active (clicked/pressed) effect
        '&:active': {
          backgroundColor: '#fefefe',
          color: '#4c4c4dff',
          transform: 'translateY(0) scale(0.99)',
          //   boxShadow: 2,
          transition: 'all 0.1s ease',
        },

        // Optional: Focus style for keyboard navigation
        '&:focus-visible': {
          outline: '3px solid #ffff00',
          outlineOffset: 4,
        },
      }}
      onClick={() => handleRedirect(item.link)}
    >
      <Box
        sx={{
          width: '100%',
          borderBottom: '1px solid #e9e9e9',
          backgroundColor: '#f2f6f8',
          borderTopRightRadius: '10px',
          borderTopLeftRadius: '10px',
          textAlign: 'center',
          //   height: '85%',
        }}
      >
        {/* <Box sx={{ paddingTop: '20px' }}>
          <Typography variant="h4">{item.title}</Typography>
        </Box> */}
        <Box
          sx={{
            // marginX: 3,
            padding: 4,
            // marginTop: 4,
          }}
        >
          <img
            src={item.img}
            alt={item.title}
            style={{
              borderRadius: 10,
              //   marginTop: 30,
              //   boxShadow:
              //     'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
              boxShadow:
                'rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;',
            }}
          />
        </Box>
      </Box>
      <Box>
        <Stack
          direction="column"
          spacing={1}
          className="w-full"
          justifyContent="flex-start"
          sx={{
            textAlign: 'left',
            paddingX: 4,
            paddingTop: 3,
          }}
        >
          <Typography variant="h5" sx={{ color: '#666', fontWeight: 'light' }}>
            {item.title}
          </Typography>
          {/* <Typography variant="body1">
            A todo list app to track these items that just need to get done
          </Typography> */}
        </Stack>
      </Box>
    </Box>
  );
};

interface ProjectCardProps {
  item: WorkItem;
  handleRedirect: (link: string) => void;
}

const ProjectCard = ({ item, handleRedirect }: ProjectCardProps) => {
  return (
    <Box
      onClick={() => handleRedirect(item.link)}
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%', // or '100%' if inside a grid
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
        transition: 'all 0.3s ease',
        // backgroundColor: '#efefef',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 8px 12px rgba(0,0,0,0.20)',
          '& .overlay': {
            opacity: 1,
          },
        },
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={item.img}
        alt={item.title}
        sx={{
          width: '100%',
          height: '100%',
          padding: 4,
          transition: 'transform 0.4s ease',
          '&:hover': {
            transform: 'scale(1.02)',
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          // background: 'rgb(83, 153, 223)',
          background: 'rgb(244, 244, 244)',
          backdropFilter: 'blur(1px)',
          py: 2.5,
          px: 3,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: 'rgb(83, 153, 223)',
            fontWeight: 600,
            letterSpacing: '0.4px',
          }}
        >
          {item.title}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyWork;
